var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoiseSuppressionOn = function SvgNoiseSuppressionOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5a.833.833 0 0 0-.833.833v13.334a.833.833 0 0 0 1.666 0V3.333A.833.833 0 0 0 10 2.5ZM6.667 5a.833.833 0 0 0-.834.833v8.334a.833.833 0 0 0 1.667 0V5.833A.833.833 0 0 0 6.667 5ZM2.5 8.333a.833.833 0 0 1 1.667 0v3.334a.833.833 0 0 1-1.667 0V8.333Zm10 0a.833.833 0 0 1 1.667 0v3.334a.833.833 0 0 1-1.667 0V8.333Zm3.333-2.5a.833.833 0 0 1 1.667 0v8.334a.833.833 0 0 1-1.667 0V5.833Z"
  })));
};
export default SvgNoiseSuppressionOn;